import React from 'react';

import classnames from 'classnames';

import Card from '@/components/elements/Card';
import HtmlContent from '@/components/elements/HtmlContent';
import Close from '@/components/Icon/Close';
import FlyOutIcon from '@/components/Icon/FlyOut';
import Image from '@/components/Image';
import tagmanager from '@/tagmanager';

import './PromotionBonusCard.scss';

class PromotionBonusCard extends React.Component {
  closeCard = () => {
    const { toggleFlyout } = this.props;

    toggleFlyout?.(false);
  };

  handleTellMeMoreClick = (e) => {
    const { descriptionHeader, openFlyoutText, toggleFlyout } = this.props;

    const buttonText = openFlyoutText;
    tagmanager.tracker.common.trackLinkClick({
      labels: [buttonText, descriptionHeader, tagmanager.trackerConstants.FLYOUTS.SAIL_WITH_CELEBRATIONS_MODULE],
    });
    toggleFlyout?.(e);
  };

  render() {
    const {
      additionalClassNames,
      captionText,
      cardInfoDescription,
      cardInfoHeader,
      descriptionHeader,
      descriptionText,
      imgSrc,
      isUnclosable,
      openFlyoutText,
    } = this.props;
    return (
      <Card className={classnames(additionalClassNames, 'promotionBonusCard')}>
        {isUnclosable && (
          <button aria-label="Close" className="close__button" onClick={this.closeCard} type="button">
            <Close />
          </button>
        )}
        <div className="promotionBonusCard__card-container">
          <section className="promotionBonusCard__card">
            <p className="promotionBonusCardBanner__header">
              <HtmlContent content={cardInfoHeader} node="span" />
            </p>
            <p className="promotionBonusCardBanner__subHeader">
              <HtmlContent content={cardInfoDescription} node="span" />
            </p>
          </section>
          <div className="promotionBonusCard__img">
            <Image alt={captionText} src={imgSrc} />
          </div>
        </div>
        <article className="promotionBonusCard__info">
          <p className="promotionBonusCardInfoHeader">
            <HtmlContent content={descriptionHeader} node="span" />
          </p>
          <p className="promotionBonusCardInfoSubHeader">
            <HtmlContent content={descriptionText} node="span" />
          </p>
          {openFlyoutText && (
            <button className="openFlyoutText" onClick={this.handleTellMeMoreClick} type="button">
              <HtmlContent content={openFlyoutText} node="span" />
              <FlyOutIcon />
            </button>
          )}
        </article>
      </Card>
    );
  }
}

PromotionBonusCard.defaultProps = {
  additionalClassNames: '',
  captionText: '',
  cardInfoDescription: '',
  cardInfoHeader: '',
  descriptionHeader: '',
  descriptionText: '',
  openFlyoutText: '',
};

export default PromotionBonusCard;
